import React from "react";

// The small motion used when the Monthly / Yearly switch changes: a sliding highlight on the switch and prices that glide in.
// Both are switched off for people who ask their device for reduced motion.

const CSS = `
@keyframes priceSwap { from { opacity: 0; transform: translateY(10px) scale(.97); filter: blur(2px); } to { opacity: 1; transform: none; filter: none; } }
.price-swap { animation: priceSwap .45s cubic-bezier(.16,1,.3,1) both; }
.price-swap > * { animation: priceSwap .45s cubic-bezier(.16,1,.3,1) both; }
.price-swap > *:nth-child(2) { animation-delay: .06s; }
.price-swap > *:nth-child(3) { animation-delay: .12s; }
/* slot-machine digits: each digit is the real text; a strip of 0-9 above it rolls past and settles on it */
.roll { font-variant-numeric: tabular-nums; display: inline-block; height: 1em; line-height: 1; overflow: hidden; vertical-align: bottom; }
.roll > span { display: inline-block; line-height: 1; animation: rollDown var(--roll-ms, .6s) cubic-bezier(.2,.8,.2,1) var(--roll-delay, 0s) both; }
.roll > span::before { content: "0\\A 1\\A 2\\A 3\\A 4\\A 5\\A 6\\A 7\\A 8\\A 9\\A 0\\A 1\\A 2\\A 3\\A 4\\A 5\\A 6\\A 7\\A 8\\A 9"; white-space: pre; display: block; opacity: .55; }
@keyframes rollDown { from { transform: translateY(0); } to { transform: translateY(-20em); } }
.billing-thumb { transition: transform .35s cubic-bezier(.34,1.3,.5,1); }
@media (prefers-reduced-motion: reduce) { .price-swap, .price-swap > * { animation: none; } .billing-thumb { transition: none; } .roll > span { animation: none; } .roll > span::before { display: none; } }
`;

// "$79" with each digit rolling into place like a slot machine, left to right. The text itself is unchanged, so it reads and tests as before.
export function Rolling({ text }) {
  let n = 0;
  return <span style={{ whiteSpace: "nowrap" }}>{String(text).split("").map((ch, i) => /\d/.test(ch)
    ? <span key={i} className="roll"><span style={{ "--roll-ms": `${0.55 + n * 0.12}s`, "--roll-delay": `${n++ * 0.04}s` }}>{ch}</span></span>
    : <span key={i}>{ch}</span>)}</span>;
}

export function PriceMotionStyle() { return <style>{CSS}</style>; }

// Monthly / Yearly with a highlight that slides from one side to the other. Same buttons and test ids as before.
export function BillingToggle({ billing, onChange, testId }) {
  return (
    <div className="relative inline-grid grid-cols-2 rounded-[10px] bg-[#EEF5F0] p-1" role="group" aria-label="Billing period">
      <span aria-hidden="true" className="billing-thumb absolute bottom-1 left-1 top-1 w-[calc(50%-4px)] rounded-lg bg-forest-700 shadow-sm"
        style={{ transform: billing === "yearly" ? "translateX(100%)" : "translateX(0)" }} />
      {["monthly", "yearly"].map((b) => (
        <button key={b} type="button" aria-pressed={billing === b} onClick={() => onChange(b)} data-testid={testId(b)}
          className={`relative z-10 min-h-[44px] rounded-lg px-5 text-xs font-extrabold uppercase tracking-wider transition-colors duration-300 focus:outline-none focus-visible:ring-2 focus-visible:ring-gold-500 ${billing === b ? "text-sand-100" : "text-forest-700"}`}>{b}</button>))}
    </div>
  );
}
